import { MetaMaskSDK } from '@metamask/sdk';

export const initializeMetaMaskSDK = () => {
  const metaMaskSdk = new MetaMaskSDK({
    dappMetadata: {
      name: 'Explore Kinetek: Where Art Meets Technology',
      url: process.env.NEXT_PUBLIC_BASE_URL || 'http://localhost:3000'
    },
    infuraAPIKey: process.env.INFURA_API_KEY || '' // Fallback for safety
  });

  return metaMaskSdk;
};
